import type { ComponentProps } from 'react'
import { Icon } from 'react-native-paper'
import { withUnistyles } from 'react-native-unistyles'

import { Theme, ThemeColorName } from '@/styles/theme'

const BaseIcon = withUnistyles(Icon)

type BaseIconProps = ComponentProps<typeof Icon>
type ThemedIconProps = Omit<BaseIconProps, 'key'>

export type UniIconProps = BaseIconProps & {
  colorName?: ThemeColorName
  getThemeProps?: (theme: Theme) => Partial<ThemedIconProps>
}

const UniIcon = ({
  color,
  colorName,
  getThemeProps,
  ...rest
}: UniIconProps) => {
  return (
    <BaseIcon
      {...rest}
      color={color}
      uniProps={(theme) => ({
        ...(color || !colorName ? {} : { color: theme.colors[colorName] }),
        ...getThemeProps?.(theme),
      })}
    />
  )
}

export default UniIcon
